export default {
  STOCK: '证券',
  FUTURES: '期货',
  FOREX: '外汇',
  IB: 'EddidPro',
  PM: '现货黄金',
  FUND: '基金',
  SECURITIES_CASH: '证券(现金)账户',
  SECURITIES_MARGIN: '证券(保证金)账户',
  FUTURES_MARGIN: '期货账户',
  MT5: '杠杆式外汇交易账户',
  MF: '外汇(Eddid FX Pro)账户',
  BULLION_MARGIN: '现货黄金账户',
  INTERACTIVE_BROKER_INTEGRATED_MARGIN: 'EddidPro账户',
  default: '账户',
  SECURITIES_AYERS_CASH: '全权委托证券(现金)账户',
  FUTURES_DAYTRADING_MARGIN: '期货日内交易账户',
  FUND_CASH: '基金账户'
}
